import React, { useEffect, useState } from 'react';

import ExpandableListItem from 'Components/shared/ExpandableListItem/ExpandableListItem';
import ListTable from 'Components/shared/ProTable/ListTable/ListTable';
import { mapFieldsToListTableValues } from 'Components/shared/ProTable/ListTable/ListTable.helpers';
import VehicleExteriorGradeTag from 'Components/shared/VehicleExteriorGradeTag/VehicleExteriorGradeTag';
import type { GradingValues } from 'Pages/vehicles/helpers/vehicle.schema';
import { triggerGradingTierClosed, triggerGradingTierExpandedOrCollapsedEvent } from 'Services/analytics/events';

import { DESCENDING_VEHICLE_GRADES_RANK_ORDER } from '../../VehicleDetailsExteriorGrading.const';
import { EXTERIOR_GRADE_FIELDS, getExteriorGradeText } from '../ExteriorGrading.helpers';
import exteriorGradingText from '../ExteriorGrading.texts';

import styles from './ExteriorGradingAccordion.module.scss';

export const ExteriorGradingAccordion: React.FC<{ initialExteriorGrade: GradingValues }> = ({
	initialExteriorGrade,
}) => {
	const [selectedExteriorGrade, setSelectedExteriorGrade] = useState<GradingValues | ''>(initialExteriorGrade);

	useEffect(() => {
		setSelectedExteriorGrade(initialExteriorGrade);
	}, [initialExteriorGrade]);

	const onClick = (exteriorGrade: GradingValues) => {
		const shouldClose = exteriorGrade === selectedExteriorGrade;
		const isClosingOtherGradeAccordion = !!(selectedExteriorGrade && !shouldClose);

		setSelectedExteriorGrade(shouldClose ? '' : exteriorGrade);

		if (shouldClose) {
			triggerGradingTierExpandedOrCollapsedEvent({ grade: getExteriorGradeText(exteriorGrade), isExpand: false });
			return;
		}

		if (isClosingOtherGradeAccordion) {
			triggerGradingTierClosed(getExteriorGradeText(selectedExteriorGrade));
		}

		triggerGradingTierExpandedOrCollapsedEvent({ grade: getExteriorGradeText(exteriorGrade), isExpand: true });
	};

	return (
		<ul className={styles.exteriorGradingAccordionContainer}>
			{DESCENDING_VEHICLE_GRADES_RANK_ORDER.map((exteriorGrade) => (
				<li key={exteriorGrade} className={styles.expandable}>
					<ExpandableListItem
						classNames={{
							container: styles.itemContainer,
							content: styles.itemContent,
							contentWrapper: styles.itemContentWrapper,
							expanded: styles.itemExpanded,
							header: styles.itemHeader,
						}}
						id={`exterior-grading-accordion-${exteriorGrade}`}
						isExpanded={exteriorGrade === selectedExteriorGrade}
						onClick={() => onClick(exteriorGrade)}
						title={
							<div className={styles.itemTitle}>
								<VehicleExteriorGradeTag
									noBackground
									exteriorGrade={exteriorGrade}
									textClassName={styles.exteriorGradeTagText}
								/>
							</div>
						}
					>
						<div aria-labelledby={`exterior-grading-accordion-${exteriorGrade}`} role="region">
							<ListTable
								omitNils
								// @ts-ignore
								values={mapFieldsToListTableValues({
									fields: EXTERIOR_GRADE_FIELDS,
									source: exteriorGradingText.values[exteriorGrade as keyof typeof exteriorGradingText.values],
								})}
							/>
						</div>
					</ExpandableListItem>
				</li>
			))}
		</ul>
	);
};
